import { useRef, RefObject } from "react"

export function useFocus<TRef extends HTMLElement = HTMLInputElement>(): [RefObject<TRef>, () => void] {
    const htmlElementRef = useRef<TRef>(null);
    const setFocus = () => { htmlElementRef.current && htmlElementRef.current!.focus(); console.log(htmlElementRef.current); };

    return [ htmlElementRef, setFocus ];
}